import API from 'utils/api';

const baseURI = '/estructura-organizacional/leer-documento/';

// Envía el documento al servidor para leer sus datos (CURP, RFC, NSS, CIC). El archivo no se
// guarda. Regresa los datos leídos o lanza el error para que lo muestre `onError`.
const leerDocumento = async (tipo, archivo) => {
  const formData = new FormData();
  formData.append('tipo', tipo);
  formData.append('archivo', archivo);
  const response = await API.post(baseURI, formData);
  return response.data;
};

export default leerDocumento;
